module.exports = __webpack_public_path__ + "static/GiftGenieLogo-6b7f247b15fa9bc794dcc35e5b4df1c4.png";